import { render, staticRenderFns } from "./BookingsNav.vue?vue&type=template&id=aff84fce&"
import script from "./BookingsNav.vue?vue&type=script&lang=js&"
export * from "./BookingsNav.vue?vue&type=script&lang=js&"
import style0 from "./BookingsNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports